import { CronosFilterPage } from './../cronos-filter/cronos-filter';
import { CronosRemoveTaskAction } from './../../store/action/CronosActions';
import { ProjectModel, ProjectTaskModel, ProjectListModel, TeamModel } from './../../model/CronosModel';
import { CronosActionPage } from './../cronos-action/cronos-action';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, reorderArray, ToastController, LoadingController, Loading, FabContainer, AlertController, PopoverController } from 'ionic-angular';
import { AppStore } from '../../store/AppStore';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { LogoutAction } from '../../store/action/UserActions';
import { SurveyClearErrorsAction } from '../../store/action/SurveyActions';
import { TrainingClearErrorsAction } from '../../store/action/TrainingActions';
import { BrainstormClearErrorsAction } from '../../store/action/BrainstormActions';
import { ClearNotificationsAction } from '../../store/action/NotificationActions';
import { CronosClearErrorsAction, CronosReorderAction } from '../../store/action/CronosActions';
import { LoginPage } from '../login/login';
import { CronosService } from '../../services/CronosService';

/**
 * Generated class for the CronosListsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

import _ from 'lodash';

@IonicPage()
@Component({
  selector: 'page-cronos-lists',
  templateUrl: 'cronos-lists.html',
})
export class CronosListsPage {

  public canReorder: boolean = false;
  public selectedProject: ProjectModel;
  public selectedTeam: TeamModel;
  public title: string;
  public loader: Loading;
  public searchInput: string = '';
  public shouldShowCancelSearch: boolean;
  public data: Array<{ type: number, model: any, parent: any }>;
  public filteredData: Array<{ type: number, model: any, parent: any }>;
  public filteredStatus: Array<number>;

  private userId: number;
  private clientId: number;

  private isLoading: boolean;
  private loggingOff: boolean;

  private savingReorder: boolean;
  private savingRemove: boolean;
  private taskToRemove: ProjectTaskModel;
  private saveProject: boolean;
  private isSavingProject: boolean;

  private userSubscription: Subscription;
  private cronosSubscription: Subscription;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private store: Store<AppStore>,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private popoverCtrl: PopoverController,
    private cronosService: CronosService) {
  }

  ionViewWillEnter() {

    this.loggingOff = false;

    this.isLoading = false;
    this.savingReorder = false;
    this.savingRemove = false;
    this.saveProject = false;
    this.userSubscription = this.store.select('userState').subscribe(userState => {
      if (userState.expired == true && !this.loggingOff) {
        this.loggingOff = true;
        this.logoff();
      }
      if (userState.user != null) {
        this.userId = userState.user.id;
        this.clientId = userState.user.clienteId;
        this.loadLists();
      }
    });

    this.cronosSubscription = this.store.select('cronosState').subscribe(cronosState => {
      if ((cronosState.savingReoder || cronosState.removingTask || cronosState.savingProject) && !this.isLoading) {
        if (this.loader == null) {
          this.loader = this.loadingCtrl.create({
            content: "Aguarde..."
          });
          this.loader.present();
        }
        if (cronosState.savingReoder) {
          this.savingReorder = true;
        }
        this.isLoading = true;
      }
      if (!cronosState.savingReoder && !cronosState.removingTask && !cronosState.savingProject && this.isLoading) {
        this.isLoading = false;
        if (this.savingReorder) {
          this.savingReorder = false;
          if (this.taskToRemove != null) {
            this.savingRemove = true;
            this.store.dispatch(new CronosRemoveTaskAction({ projectId: this.selectedProject.id, listId: this.taskToRemove.currentListId, model: this.taskToRemove }));
            this.taskToRemove = null;
          } else {
            this.loader.dismiss();
            this.loader = null;
            if (this.saveProject) {
              this.saveProject = false;
              this.selectedProject = cronosState.projects.find(x => x.id == this.selectedProject.id);
              this.isSavingProject = true;
            }
          }
        } else if (this.savingRemove) {
          this.savingRemove = true;
          this.loader.dismiss();
          this.loader = null;
          this.presentToast('Ação removida com sucesso');
          this.shouldShowCancelSearch = false;
          this.filter();
        } else if (this.isSavingProject) {
          this.isSavingProject = false;
          this.loader.dismiss();
          this.loader = null;
          this.presentToast('Lista adicionada com sucesso');
          this.loadLists();
        }
      }
      if (cronosState.errorReorder) {
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao reordenar os dados');
          }
          if (this.isLoading) {
            this.loader.dismiss();
            this.loader = null;
            this.isLoading = false;
          }
        }, 200);
      }
      if (cronosState.errorRemovingTask) {
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao remover tarefa');
          }
          if (this.isLoading) {
            this.loader.dismiss();
            this.loader = null;
            this.isLoading = false;
          }
        }, 200);
      }
      if (cronosState.errorSavingProject) {
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao gravar o projeto');
          }
          if (this.isLoading) {
            this.loader.dismiss();
            this.loader = null;
            this.isLoading = false;
          }
        }, 200);
      }
    });
  }

  loadLists() {
    this.selectedTeam = this.navParams.get('team') ? this.navParams.get('team') : this.selectedTeam;

    if (this.navParams.get('project')) {
      this.selectedProject = this.navParams.get('project');
      this.title = this.selectedProject.name;

      this.cronosService.findOverviewByBoardId(this.selectedProject.id)
        .subscribe(data => {
          var lists = this.cronosService.mapLists(data || []);
          this.selectedProject.lists = _.orderBy(lists, ['position'], ['asc']);
          this.fillData();
          this.selectedProject = this.cronosService.completeProjectData(this.selectedProject, this.selectedTeam);
          this.filter();
        });
    }
    this.shouldShowCancelSearch = false;
  }

  ionViewWillLeave() {
    if (this.userSubscription != null) this.userSubscription.unsubscribe();
    if (this.cronosSubscription != null) this.cronosSubscription.unsubscribe();
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  logoff() {
    this.presentToast('Acesso expirado. Efetue login novamente. (3)');
    localStorage.removeItem('expirationDate');
    this.store.dispatch(new LogoutAction());
    this.store.dispatch(new SurveyClearErrorsAction());
    this.store.dispatch(new TrainingClearErrorsAction());
    this.store.dispatch(new BrainstormClearErrorsAction());
    this.store.dispatch(new ClearNotificationsAction());
    this.store.dispatch(new CronosClearErrorsAction());
    this.navCtrl.setRoot(LoginPage);
  }

  search() {
    this.shouldShowCancelSearch = true;
    this.filter();
  }

  filter() {
    this.filteredData = this.data.filter(
      x => x.type == 1 ||
        (
          x.type == 2 && (
            this.searchInput == '' ||
            x.model.name.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0 ||
            (x.model.description != null && x.model.description.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0)
          )
        )
    );
    if (this.filteredStatus != null) {
      this.filteredData = this.filteredData.filter(x => x.type == 1 || (x.type == 2 && this.filteredStatus.find(y => y == x.model.status) != null));
    }
  }

  cancelSearch() {
    this.searchInput = '';
    this.shouldShowCancelSearch = false;
    this.filter();
  }

  fillData() {
    this.data = [];
    this.selectedProject.lists.forEach(list => {
      if (this.selectedProject.teamId != null ||
        this.selectedProject.userId == this.userId ||
        list.tasks.filter(x => x.users.filter(y => y.userId == this.userId).length > 0).length > 0) {
        list.isOpen = true;
        this.data.push({ type: 1, model: list, parent: null });
      }
      list.tasks.forEach(task => {
        if (this.selectedProject.teamId != null ||
          this.selectedProject.userId == this.userId ||
          task.users.filter(x => x.userId == this.userId).length > 0) {
          this.data.push({ type: 2, model: task, parent: list });
        }
      });
    });
  }

  toggleSection(model: any) {
    model.isOpen = !model.isOpen;
    this.data.forEach(item => {
      if (item.type == 2 && item.parent != null && item.parent.id == model.id) {
        item.parent.isOpen = model.isOpen;
      }
    })
  }

  getColor(status: number) {
    switch (status) {
      case 0:
        return 'disabled';
      case 1:
        return 'primary';
      case 2:
        return 'secondary';
      case 3:
        return 'danger';
      default:
        return 'primary';
    }
  }

  getDescription(status: number) {
    switch (status) {
      case 0:
        return 'Não Iniciado';
      case 1:
        return 'Em andamento';
      case 2:
        return 'Concluído';
      case 3:
        return 'Expirado';
      default:
        return 'Em andamento';
    }
  }

  toggleReorder() {
    if (this.shouldShowCancelSearch == false) {
      this.canReorder = !this.canReorder;
    }
  }

  reorderItems(indexes) {
    if (indexes.to == 0) {
      return;
    }

    let listFrom = this.data[indexes.from].parent;
    let listTo = this.data[indexes.to].parent;
    if (this.data[indexes.to].type == 1) {
      listTo = this.data[indexes.to].model;
    }

    this.data = reorderArray(this.data, indexes);

    let position: number = 0;
    let currentParent = null;
    this.data.forEach(item => {
      if (item.type == 1) {
        position = 0;
        currentParent = item.model;
      }
      else {
        item.parent = currentParent;
        item.model.position = position;
        position++;
      }
    });

    listFrom.tasks = this.data.filter(x => x.type == 2 && x.parent.id == listFrom.id).map(x => x.model).sort((a, b) => { return a.positon < b.position ? -1 : 1; });
    this.updateParentInfo(listFrom);

    if (listFrom.id != listTo.id) {
      listTo.tasks = this.data.filter(x => x.type == 2 && x.parent.id == listTo.id)
        .map(x => {
          x.model.listId = listTo.id;
          return x.model;
        })
        .sort((a, b) => { return a.positon < b.position ? -1 : 1; });

      this.updateParentInfo(listTo);
      this.cronosService.refreshPositionTasks(listTo.tasks).subscribe();
      this.filter();
      return;
    }

    this.cronosService.refreshPositionTasks(listFrom.tasks).subscribe();
    this.filter();

  }

  updateParentInfo(listItem: ProjectListModel) {
    this.data.forEach(item => {
      if (item.type == 1 && item.model.id == listItem.id) {
        item.model = listItem;
      } else if (item.type == 2 && item.parent.id == listItem.id) {
        item.parent = listItem;
      }
    });
  }

  openAction(list: ProjectListModel, task: ProjectTaskModel) {
    this.navCtrl.push(CronosActionPage, { projectId: this.selectedProject.id, list, task, team: this.selectedTeam, edit: true, lists: this.selectedProject.lists, ownerId: this.selectedProject.userId });
  }

  addAction(list: ProjectListModel) {
    const prompt = this.alertCtrl.create({
      title: 'Nova Ação',
      message: "Digite o nome da Nova Ação",
      inputs: [
        {
          name: 'nome',
          placeholder: 'Nome'
        },
      ],
      buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Salvar',
          handler: data => {
            if (data != null && data.nome != null && data.nome != '') {
              this.cronosService.saveTask(this.newTask(data.nome, list.id)).subscribe(task => {
                list.tasks.push(_.assign({}, task));
                this.saveList(list);
                this.openAction(list, task);
              });
            } else {
              this.presentToast('Digite um Nome para a Nova Lista de Ações');
              return false;
            }
          }
        }
      ]
    });
    prompt.present();
  }

  newTask(nome, list) {
    return { id: null, name: nome, status: 0, boardId: this.selectedProject.id, clienteId: this.clientId, listId: list }
  }

  addList(fab: FabContainer) {
    fab.close();
    const prompt = this.alertCtrl.create({
      title: 'Nova Lista de Ações',
      message: "Digite o nome da Nova Lista de Ações",
      inputs: [
        {
          name: 'nome',
          placeholder: 'Nome'
        },
      ],
      buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Salvar',
          handler: data => {
            if (data != null && data.nome != null && data.nome != '') {
              this.saveProject = true;
              this.isSavingProject = false;
              this.saveList(this.newList(data.nome));
            } else {
              this.presentToast('Digite um Nome para a Nova Lista de Ações');
              return false;
            }
          }
        }
      ]
    });
    prompt.present();
  }

  newList(nome) {
    return {
      boardId: this.selectedProject.id,
      clienteId: this.clientId,
      closed: false,
      id: null,
      name: nome,
      position: this.selectedProject.lists.length,
      isOpen: false,
      tasks: []
    }
  }

  saveList(list) {
    this.cronosService.saveList(list).subscribe(() => {
      this.presentToast('Salvo com sucesso');
      this.loadLists();
    });
  }

  removeAction(list: ProjectListModel, task: ProjectTaskModel) {
    const confirm = this.alertCtrl.create({
      title: 'Confirma Exclusão',
      buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Confirmar',
          handler: () => {
            this.confirmRemoveAction(list, task);
          }
        }
      ]
    });
    confirm.present();
  }

  confirmRemoveAction(list: ProjectListModel, task: ProjectTaskModel) {
    let idx = list.tasks.findIndex(x => x.id == task.id);
    if (idx != null) {
      this.taskToRemove = task;
      this.taskToRemove.currentListId = list.id;
      list.tasks.splice(idx, 1);
      list.tasks.forEach(item => {
        if (item.position > task.position) {
          item.position = item.position - 1;
        }
      });
      this.fillData();
      this.selectedProject = this.cronosService.completeProjectData(this.selectedProject, this.selectedTeam);
      this.store.dispatch(new CronosReorderAction({ projectId: this.selectedProject.id, model: list }));
    }
  }

  removeList(list: ProjectListModel) {
    const confirm = this.alertCtrl.create({
      title: 'Confirma Exclusão',
      buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Confirmar',
          handler: () => {
            this.confirmRemoveList(list);
          }
        }
      ]
    });
    confirm.present();
  }

  confirmRemoveList(list: ProjectListModel) {
    let idx = this.selectedProject.lists.findIndex(x => x.id == list.id);
    if (idx != null) {
      this.cronosService.removeList(list).subscribe(response => {
        this.loadLists();
        this.presentToast('Lista removida com sucesso');
      });
    }
  }

  isOwner(): boolean {
    if (this.selectedProject && this.selectedTeam) {
      if (this.selectedTeam.id == 0) {
        return this.selectedProject.userId == this.userId;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  openFilter(ev) {
    let popover = this.popoverCtrl.create(CronosFilterPage, {
      page: this
    });
    popover.present({
      ev: ev
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/cronos-lists/cronos-lists.ts